export default __webpack_public_path__ + "locales/ko-KR/About.json?hash=b2dc8a31a0a7e2d23658e01436a840e2";